import React from 'react';
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import {useAuth} from "features/login/context/AuthProvider";
import {Button, useModal, useToast} from "shared/ui";

export const MainTemplate = () => {
  const {t} = useTranslation("common");
  const {authenticated, logout} = useAuth();
  const toast = useToast();
  const modal = useModal();
  
  const handleLogoutConfirm = async () => {
    await logout();
    toast.success(t("로그아웃됐습니다."));
  };
  
  const handleLogout = () => {
    modal.confirm({children: t("로그아웃을 계속 진행할까요?"), onConfirm: handleLogoutConfirm});
  };
  
  return (<div className={"layout-main"}>
    <div className={"header"}>
      <div className={" title"}>{t("header")}</div>
      {authenticated && <Button variant={"link"} className={" logout"} onClick={handleLogout}>{t("logout")}</Button>}
    </div>
    <main className={" content"}>
      <Outlet />
    </main>
  </div>);
};
